import type { Ref } from "react";
import { Link, useLocation, type LinkProps } from "react-router";
import { withQueryParams } from "./navigateWithQueryParams";

export const LinkWithQueryParams = ({ to, ref, ...props }: LinkProps & { ref?: Ref<HTMLAnchorElement> }) => {
  const { search } = useLocation();

  return <Link ref={ref} to={typeof to === "string" ? withQueryParams(to, search) : to} {...props} />;
};
